import React from "react";
import { YStack, Text } from "tamagui";
import { format, parse } from "date-fns";

import { Event } from "../../../../types/event";
import { EventDetailDescription } from "./EventDetailDescription";

type EventDetailInfoProps = {
  description: string | null | undefined;
  date: string | null | undefined;
  time: string | null | undefined;
  location: string | null | undefined;
  visibility: Event["visibility"];
  eventType: Event["type"];
  host: Event["host"];
  onHostPress: (userId: string) => void;
};

export const EventDetailInfo = ({
  description,
  date,
  time,
  location,
  eventType,
}: EventDetailInfoProps) => {
  const eventDate = date && parse(date, "yyyy-MM-dd", new Date());
  const timeObj = time && parse(time, "HH:mm:ss", new Date());

  const formattedTime = timeObj && format(timeObj, "hh:mm a");
  const formattedDate = eventDate && format(eventDate, "MM/dd/yyyy");

  return (
    <YStack alignItems="flex-start" pt="$4" gap="$4" px="$4">
      <YStack gap="$2" flexShrink={0}>
        <YStack>
          <Text fontFamily="$heading" fontSize={16} textTransform="uppercase">
            Ride Details
          </Text>
          {eventType === "Babes" ? <BabesInfo /> : null}
        </YStack>
        <Text textTransform="uppercase">
          {formattedDate} @ {formattedTime}
        </Text>
        <Text textTransform="uppercase">
          {location ? location : "Location TBD"}
        </Text>
        <EventDetailDescription description={description} />
      </YStack>
    </YStack>
  );
};

const BabesInfo = () => {
  return (
    <YStack>
      <Text>
        A ride for women, women-identifying individuals, and non-binary
        communities who are comfortable in a space that centers the experiences
        of women who bike.
      </Text>
    </YStack>
  );
};
